export var indefiniteArticle = function(string) {
    return /^[aeiou]/i.test(string) ? "an" : "a";
};
